import { projWidgetTypes } from "../_constants/widgetTypes";
import { BASE_URL } from "../_constants/urlConstants";

/**
 * Data access helper for project dashboard widgets that have
 * API calls. Holds instructions for fetching the data.
 * Used by action creator to pool all API calls together.
 * @returns {Object} Normalized by widgetType constant
 */
export const projWidgetApiEndpoints = {
  [projWidgetTypes.SAFETY_COMMENTS_RAISED]: {
    apiEndpoint: BASE_URL + "/api/ProjectAdmin/GetCountOfSafetyComments",
    params: projectId => ({ params: { projectId } })
  }
};
